<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      :title="titles[0]"
      center
      width="746px"
      :before-close="$onClose"
      destroy-on-close
    >
      <div style="margin: 30px 100px 30px 20px;background-color: transparent;">
        <div>
          <h4 class="title">{{titles[1]}}</h4>
          <el-date-picker
            v-if="showDiv1Picker"
            v-model="input_1"
            type="datetime"
            placeholder="选择时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
          <el-select v-if="showDiv1SelectEdu" v-model="input_1" placeholder="请选择">
            <el-option v-for="item in eduStatusOptions" :key="item" :value="item"></el-option>
          </el-select>
          <el-select
            v-if="showDiv1SelectJob"
            v-model="input_1"
            placeholder="请选择"
            @change="changeSelectJob"
          >
            <el-option v-for="item in workStatusOptions" :key="item" :value="item"></el-option>
          </el-select>
        </div>
        <div v-if="showDiv2">
          <h4 class="title">{{titles[2]}}</h4>
          <el-input v-model="input_2" placeholder="请输入"></el-input>
        </div>
        <div v-if="showDiv3">
          <h4 class="title">{{titles[3]}}</h4>
          <el-input id="el_input_3" v-model="input_3" placeholder="请输入" @input.native="inputHandle"></el-input>
        </div>
        <div v-if="showDiv4">
          <h4 class="title">{{titles[4]}}</h4>
          <el-input id="el_input_4" v-model="input_4" placeholder="请输入"></el-input>
        </div>
        <div v-if="showDiv5">
          <h4 class="title">{{titles[5]}}</h4>
          <el-input v-if="showDiv5Job" v-model="input_5" placeholder="请输入"></el-input>
          <el-date-picker
            v-if="showDiv5Edu"
            v-model="input_5"
            type="year"
            placeholder="选择年"
            value-format="yyyy"
          ></el-date-picker>
        </div>
        <div v-if="showDiv6">
          <h4 class="title">{{titles[6]}}</h4>
          <el-input v-model="input_6" placeholder="请输入"></el-input>
        </div>
        <div v-if="showDiv7">
          <h4 class="title">{{titles[7]}}</h4>
          <el-input v-model="input_7" placeholder="请输入"></el-input>
        </div>
        <div v-if="showDiv8">
          <h4 class="title">{{titles[8]}}</h4>
          <el-input v-model="input_8" placeholder="请输入"></el-input>
        </div>
        <div v-if="showDiv9">
          <h4 class="title">{{titles[9]}}</h4>
          <el-input v-model="input_9" placeholder="请输入"></el-input>
        </div>
        <div v-if="showDiv10">
          <h4 class="title">{{titles[10]}}</h4>
          <el-input v-model="input_10" placeholder="请输入"></el-input>
        </div>
        <div v-if="showDiv11">
          <h4 class="title">{{titles[11]}}</h4>
          <el-input v-model="input_11" placeholder="请输入"></el-input>
        </div>
         <div v-if="showDiv12">
          <h4 class="title">{{titles[12]}}</h4>
          <el-input v-model="input_12" placeholder="请输入"></el-input>
        </div>
      </div>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right;"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
        >保存</el-button>
        <el-button
          style="width: 106px; float: right;  margin-right: 15px;"
          size="small"
          @click="close()"
        >取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/strUtils";
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
import * as Constant from "@/utils/constant.js";

var thisIndex;
var thisUserName;
var thisType;
var thisInfo = {};

export default {
  data() {
    return {
      changVisible: false,

      showDiv1Picker: false,
      showDiv1SelectEdu: false,
      showDiv1SelectJob: false,
      showDiv2: false,
      showDiv3: false,
      showDiv4: false,
      showDiv5: false,
      showDiv5Job: false,
      showDiv5Edu: false,
      showDiv6: false,
      showDiv7: false,
      showDiv8: false,
      showDiv9: false,
      showDiv10: false,
      showDiv11: false,
      showDiv12: false,

      titles: [],

      input_1: "",
      input_2: "",
      input_3: "",
      input_4: "",
      input_5: "",
      input_6: "",
      input_7: "",
      input_8: "",
      input_9: "",
      input_10: "",
      input_11: "",
      input_12: "",
      clickLastTime: 0, //默认上一次点击时间为0
      eduStatusOptions: Constant.edu_status_options, //深造状态
      workStatusOptions: Constant.work_status_options, //工作状态
      unitOptions: Constant.unit_options, //单位性质
      jobTypeOptions: Constant.job_type_options, //行业类型
      payOptions: Constant.pay_options, //薪酬范围
      employeesOptions: Constant.employees_options, //雇员人数
      turnoverOptions: Constant.turnover_options, //年营业额
    };
  },
  methods: {
    changeSelectJob(select) {
      console.log(select);
      switch (select) {
        case "待业":
        case "深造":
          break;
        case "就业":
          this.showDiv2 = true;
          this.showDiv3 = true;
          this.showDiv4 = true;
          this.showDiv5 = true;
          this.showDiv5Job = true;
          this.showDiv6 = true;
          this.showDiv7 = true;
          break;
        case "自主创业":
          this.showDiv2 = true;
          this.showDiv3 = true;
          this.showDiv4 = true;
          this.showDiv5 = true;
          this.showDiv5Job = true;
          this.showDiv6 = true;
          this.showDiv7 = true;
          this.showDiv8 = true;
          this.showDiv9 = true;
          this.showDiv10 = true;
          break;
        case "自由职业":
          this.showDiv3 = true;
          this.showDiv6 = true;
          this.showDiv11 = true;
          this.showDiv12 = true;
          break;
      }
    },
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    inputHandle({ target }) {
      // if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+2)}
      target.value = target.value.replace(/([^0-9.])+/g, "");
    },
    save() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;

      if (thisInfo == undefined) {
        thisInfo = {};
        thisInfo.id = 0;
      }
      thisInfo.delete_time = 0;
      switch (thisType) {
        case "ais_education":
          var year = new Date().getFullYear();
          if (
            isEmpty(this.input_1) ||
            isEmpty(this.input_2) ||
            isEmpty(this.input_3) ||
            isEmpty(this.input_4) ||
            isEmpty(this.input_5)
          ) {
            this.$message.error("请完善信息");
            return;
          }
          thisInfo.education_status = this.input_1;
          thisInfo.education_city = this.input_2;
          thisInfo.education_school = this.input_3;
          thisInfo.education_programme = this.input_4;
          thisInfo.education_graduation_year = this.input_5;
          break;
        case "ais_job_info":
          if (
            isEmpty(this.input_1) ||
            isEmpty(this.input_4) ||
            isEmpty(this.input_5) ||
            isEmpty(this.input_9) ||
            isEmpty(this.input_10)
          ) {
            this.$message.error("请完善信息");
            return;
          }
          thisInfo.status = this.input_1;
          thisInfo.organization_city = this.input_2;
          thisInfo.organization = this.input_3;
          thisInfo.unit_property = this.input_4;
          thisInfo.job_type = this.input_5;
          thisInfo.registered_address = this.input_6;
          thisInfo.employees = this.input_7;
          thisInfo.turnover = this.input_8;
          thisInfo.position = this.input_9;
          thisInfo.pay = this.input_10;
          break;
        case "ais_journal":
          if (isEmpty(this.input_1) || isEmpty(this.input_2)) {
            this.$message.error("请完善信息");
            return;
          }
          var timestamp1 = parseInt(new Date().getTime());
          var timeStr = this.input_1.replace(/-/g, "/");
          var timestamp2 = new Date(timeStr).getTime();

          thisInfo.journal_time = this.input_1;
          thisInfo.content = this.input_2;
          thisInfo.money = this.input_3;
          thisInfo.type = this.input_4;
          thisInfo.remark = this.input_5;
          break;
        case "ais_honor":
          if (isEmpty(this.input_1) || isEmpty(this.input_2)) {
            this.$message.error("请完善信息");
            return;
          }
          var timestamp1 = parseInt(new Date().getTime());
          var timeStr = this.input_1.replace(/-/g, "/");
          var timestamp2 = new Date(timeStr).getTime();
          thisInfo.honor_time = this.input_1;
          thisInfo.content = this.input_2;
          break;
      }
      this.changVisible = false;
      this.$emit("toSave", thisIndex, thisType, thisInfo);
    },
    //页面初始化时加载的事件
    show(index, userName, type, info) {
      this.cleanInput();
      this.changVisible = true;
      thisIndex = index;
      thisUserName = userName;
      thisType = type;
      thisInfo = info;
      switch (thisType) {
        case "ais_education":
          this.showDiv1SelectEdu = true;
          this.showDiv2 = true;
          this.showDiv3 = true;
          this.showDiv4 = true;
          this.showDiv5 = true;
          this.showDiv5Edu = true;
          if (thisInfo === undefined) {
            this.initEducation();
          } else {
            this.editEducation(thisInfo);
          }
          break;
        case "ais_job_info":
          this.showDiv1SelectJob = true;
          if (thisInfo === undefined) {
            this.initJobInfo();
          } else {
            this.editJobInfo(thisInfo);
          }
          break;
        case "ais_journal":
          this.showDiv1Picker = true;
          this.showDiv2 = true;
          this.showDiv3 = true;
          this.showDiv4 = true;
          this.showDiv5 = true;
          if (thisInfo === undefined) {
            this.initJournal();
          } else {
            this.editJournal(thisInfo);
          }
          break;
        case "ais_honor":
          this.showDiv1Picker = true;
          this.showDiv2 = true;
          if (thisInfo === undefined) {
            this.initHonor();
          } else {
            this.editHonor(thisInfo);
          }
          break;
      }
    },
    // 清除输入框
    cleanInput() {
      this.input_1 = "";
      this.input_2 = "";
      this.input_3 = "";
      this.input_4 = "";
      this.input_5 = "";
      this.input_6 = "";
      this.input_7 = "";
      this.input_8 = "";
      this.input_9 = "";
      this.input_10 = "";
      this.input_11 = "";
      this.input_12 = "";

      this.changVisible = false;

      this.showDiv1Picker = false;
      this.showDiv1SelectEdu = false;
      this.showDiv1SelectJob = false;
      this.showDiv2 = false;
      this.showDiv3 = false;
      this.showDiv4 = false;
      this.showDiv5 = false;
      this.showDiv5Job = false;
      this.showDiv5Edu = false;
      this.showDiv6 = false;
      this.showDiv7 = false;
      this.showDiv8 = false;
      this.showDiv9 = false;
      this.showDiv10 = false;
      this.showDiv11 = false;
      this.showDiv12 = false;
    },
    // 添加深造信息
    initEducation() {
      this.titles = [
        "新增 " + thisUserName + " 深造信息",
        "*深造状态",
        "*所在地",
        "*院校名称",
        "*专业",
        "*毕业年份",
      ];
    },
    // 编辑深造信息
    editEducation(info) {
      this.initEducation();
      this.titles[0] = "编辑 " + thisUserName + " 深造信息";
      this.input_1 = info.education_status;
      this.input_2 = info.education_city;
      this.input_3 = info.education_school;
      this.input_4 = info.education_programme;
      this.input_5 = info.education_graduation_year;
    },
    // 添加工作信息
    initJobInfo() {
      this.titles = [
        "新增 " + thisUserName + " 工作信息",
        "*工作状态",
        "*单位性质",
        "*行业类型",
        "*工作职位",
        "*薪酬范围",
        "所在地",
        "单位名称",
        "公司注册地",
        "雇佣人员",
        "年营业额",
        "从事何种自由职业",
      ];
      // this.titles = [
      //   "新增 " + thisUserName + " 工作信息",
      //   "*工作状态",
      //   "所在地",
      //   "单位名称",
      //   "*单位性质",
      //   "*行业类型",
      //   "公司注册地",
      //   "雇佣人员",
      //   "年营业额",
      //   "*工作职位",
      //   "*薪酬范围",
      //   "从事何种自由职业",
      // ];
    },
    // 编辑工作信息
    editJobInfo(info) {
      this.initJobInfo();
      this.titles[0] = "编辑 " + thisUserName + " 工作信息";
      this.input_1 = info.status;
      this.input_2 = info.organization_city;
      this.input_3 = info.organization;
      this.input_4 = info.unit_property;
      this.input_5 = info.job_type;
      this.input_6 = info.registered_address;
      this.input_7 = info.employees;
      this.input_8 = info.turnover;
      this.input_9 = info.position;
      this.input_10 = info.pay;
      this.input_11 = info.freelance;
      this.input_12 = info.year;
    },
    // 添加捐助信息
    initJournal() {
      this.titles = [
        "新增 " + thisUserName + " 捐助信息",
        "*捐助时间",
        "*捐助内容",
        "捐助金额",
        "捐助类型",
        "备注",
      ];
      // document.getElementById("el_input_3").oninput =
      //   "if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}";
    },
    // 编辑捐助信息
    editJournal(info) {
      this.initJournal();
      this.titles[0] = "编辑 " + thisUserName + " 捐助信息";
      this.input_1 = info.journal_time;
      this.input_2 = info.content;
      this.input_3 = info.money;
      this.input_4 = info.type;
      this.input_5 = info.remark;
    },
    // 添加荣誉信息
    initHonor() {
      this.titles = [
        "新增 " + thisUserName + " 荣誉信息",
        "*荣誉时间",
        "*荣誉内容",
      ];
    },
    // 编辑荣誉信息
    editHonor(info) {
      this.initHonor();
      this.titles[0] = "编辑 " + thisUserName + " 荣誉信息";
      this.input_1 = info.honor_time;
      this.input_2 = info.content;
    },
  },
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/addEditInfoDialog.vue